const Flickity = require('flickity');
const logoSlider = document.querySelector('.logoSlider');

if (logoSlider) {

	const flkty = new Flickity( logoSlider, {
		// options
		cellAlign: 'left',
		contain: true,
		prevNextButtons: false,
		pageDots: false,
		wrapAround: true,
		autoPlay: 4000,
		pauseAutoPlayOnHover: false,
		groupCells: 5,
		accessibility: true
	});
}